export default __webpack_public_path__ + "static/media/email-success.915dc628.png";